export enum rootReducerActionTypes {
  'persist/PERSIST' = 'persist/PERSIST',
  'persist/REHYDRATE' = 'persist/REHYDRATE'
}
